// dashboardCache.js — загруженные цифры дашборда в sessionStorage
// (переживают F5 и смену вкладки портала, стираются при закрытии вкладки браузера).
//
// Хранятся только агрегаты (итоги, по часам, severity, статусы, топ источников),
// без содержимого алертов. Ключ — iris_customer_id, чтобы данные разных организаций
// не смешивались. При выходе и возврате в админку вызывается clearDashboardCache().

const PREFIX = 'dash_stats:';
const VERSION = 1;
export const DASHBOARD_CACHE_MAX_AGE_MS = 30 * 60 * 1000; // старше — не показываем, грузим заново

export function readDashboardCache(customerId) {
  if (!customerId) return null;
  try {
    const raw = sessionStorage.getItem(PREFIX + customerId);
    if (!raw) return null;
    const entry = JSON.parse(raw);
    if (entry.v !== VERSION || Date.now() - entry.savedAt > DASHBOARD_CACHE_MAX_AGE_MS) {
      sessionStorage.removeItem(PREFIX + customerId);
      return null;
    }
    return entry;
  } catch {
    return null; // хранилище недоступно или данные повреждены
  }
}

export function writeDashboardCache(customerId, data) {
  if (!customerId) return;
  try {
    sessionStorage.setItem(PREFIX + customerId, JSON.stringify({ v: VERSION, savedAt: Date.now(), ...data }));
  } catch {
    // хранилище переполнено или недоступно — работаем без кэша
  }
}

export function clearDashboardCache() {
  try {
    Object.keys(sessionStorage).filter(k => k.startsWith(PREFIX)).forEach(k => sessionStorage.removeItem(k));
  } catch {
    // хранилище недоступно
  }
}
